function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "sun-moon_svg__sun",
  d: "M55 27.07C38.78 27.07 28.77 39 28.77 55S38.78 83 55 83s26.26-12 26.26-28S71.11 27.07 55 27.07zm0 49.4c-12.17 0-18.72-9.22-18.72-21.46s6.53-21.6 18.72-21.6S73.63 42.7 73.63 55 67.15 76.47 55 76.47zM110.03 51.98H90.02v6.05h20.01v-6.05zM76.512 29.238L90.67 15.082l4.278 4.278L80.79 33.516zM51.99 0h6.05v20.02h-6.05zM20.02 58.03v-6.05H0v6.05h20.02zM15.085 19.35l4.278-4.278L33.519 29.23l-4.278 4.278zM15.082 90.663L29.24 76.507l4.278 4.278L19.36 94.94zM51.99 90v20.02h6.05V90h-6.05zM76.517 80.787l4.278-4.278L94.95 90.666l-4.278 4.278z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "sun-moon_svg__moon",
  d: "M28.77 55c0-16.06 10-27.94 26.21-27.94S81.26 39 81.26 55 71.11 83 55 83 28.77 71 28.77 55z"
});

function SvgSunMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110.04 110.02"
  }, props), _ref, _ref2);
}

export default SvgSunMoon;